/// <amd-module name="SuiteCommerce.GiftCertificate.PLP.Group.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.PLP.Group.View", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.Item.Model", "SuiteCommerce.GiftCertificate.Main.Configuration"], function (require, exports, Backbone_1, Item_Model_1, Main_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PLPGroupView = void 0;
    var PLPGroupView = /** @class */ (function (_super) {
        __extends(PLPGroupView, _super);
        function PLPGroupView(options) {
            var _this = _super.call(this, options) || this;
            _this.contextDataRequest = ['item'];
            _this.template = function () { return ''; };
            _this.groupsCollection = options.groupsCollection;
            _this.environment = options.environment;
            _this.facetsSelector = ".facets-item-cell-".concat(_this.getPLPDisplayFormat(options.PLP));
            options.PLP.on('afterShowContent', function () {
                if (_this.matchingGroup) {
                    _this.modifyCellData(_this.matchingGroup);
                }
            });
            return _this;
        }
        PLPGroupView.prototype.getContext = function () {
            if (this.contextData.item) {
                var item = this.getItemData();
                this.matchingGroup = this.findMatchingGroup(item);
            }
        };
        PLPGroupView.prototype.getItemData = function () {
            var itemData = this.contextData.item();
            return new Item_Model_1.ItemModel(itemData);
        };
        PLPGroupView.prototype.findMatchingGroup = function (item) {
            var matchingGroupId = this.groupsCollection.itemToGroupMap[item.id];
            if (matchingGroupId) {
                return this.groupsCollection.getGroupById(matchingGroupId);
            }
        };
        PLPGroupView.prototype.modifyCellData = function (group) {
            var cell = this.$el.parents(this.facetsSelector);
            this.removeQuickViewButton(cell);
            this.modifyTitle(cell, group.name);
            if (group.minPrice !== group.maxPrice) {
                this.modifyPrice(cell, group.minPriceStr, group.maxPriceStr);
            }
        };
        PLPGroupView.prototype.modifyTitle = function (cell, newTitle) {
            var titleElement = cell.find("".concat(this.facetsSelector, "-title"));
            titleElement.html(newTitle);
        };
        PLPGroupView.prototype.modifyPrice = function (cell, minPrice, maxPrice) {
            var priceElement = cell.find('.product-views-price-lead');
            var formattedMinPrice = this.formatPrice(minPrice);
            var formattedMaxPrice = this.formatPrice(maxPrice);
            var priceRange = Main_Configuration_1.MainConfiguration.priceRange;
            if (priceRange) {
                priceRange = priceRange.replace('[[minPrice]]', formattedMinPrice);
                priceRange = priceRange.replace('[[maxPrice]]', formattedMaxPrice);
            }
            priceElement.html(priceRange);
        };
        PLPGroupView.prototype.formatPrice = function (value) {
            var symbol;
            if (this.environment && this.environment.getSession() && this.environment.getSession().currency) {
                symbol = this.environment.getSession().currency.symbol;
            }
            return "".concat(symbol).concat(value);
        };
        PLPGroupView.prototype.removeQuickViewButton = function (parent) {
            var quickViewElement = parent.find("".concat(this.facetsSelector, "-quick-view-wrapper"));
            quickViewElement.remove();
        };
        PLPGroupView.prototype.getPLPDisplayFormat = function (PLP) {
            var _a;
            return ((_a = PLP === null || PLP === void 0 ? void 0 : PLP.getDisplay()) === null || _a === void 0 ? void 0 : _a.id) || 'grid';
        };
        return PLPGroupView;
    }(Backbone_1.View));
    exports.PLPGroupView = PLPGroupView;
});
